import React, { useEffect, useMemo, useState } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DeleteModal from '../../components/Common/DeleteModal';

// Modal séparé
import CourseComponentModal from "./partials/CourseComponentModal";

import ImportCourseComponentModal from "./partials/ImportCourseComponentModal";

import {
    getCourseComponents as onGetCourseComponents,
    addNewCourseComponent as onAddNewCourseComponent,
    updateCourseComponent as onUpdateCourseComponent,
    deleteCourseComponent as onDeleteCourseComponent,

    getStudyLevels as onGetStudyLevels,
    getTeachers as onGetTeachers,
    getSemesters as onGetSemesters,

    resetCourseComponentLastActionSuccess as OnResetCourseComponentLastActionSuccess
} from "store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import {
    Col,
    Row,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    FormFeedback,
    Label,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge,
    Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

const Subject = () => {

    //meta title
    document.title = "Éléments constitutifs | CinzanEdu";

    const dispatch = useDispatch();

    const [modal, setModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [courseComponent, setCourseComponent] = useState(null);
    const [deleteModal, setDeleteModal] = useState(false);
    const [loadingState, setLoadingState] = useState(true);

    const [modalOpen, setModalOpen] = useState(false);
    
    


    // Selector courses components
    const CourseComponentProperties = createSelector(
        (state) => state.courseComponentReducer, 
        (courseComponentReducer) => ({
            courseComponents: courseComponentReducer.courseComponents,
            loading: courseComponentReducer.loading,
            lastActionSuccess: courseComponentReducer.lastActionSuccess
        })
    );

    const {courseComponents, loading, lastActionSuccess} = useSelector(CourseComponentProperties);
    const [isLoading, setLoading] = useState(loading);

    // Selector Study levels
    const StudyLevelProperties = createSelector(
        (state) => state.studyLevelReducer, 
        (studyLevelReducer) => ({
            studyLevels: studyLevelReducer.studyLevels,
            loading: studyLevelReducer.loading
        })
    );
    const {studyLevels} = useSelector(StudyLevelProperties);


    // Selector Teachers
    const TeacherProperties = createSelector(
        (state) => state.teacherReducer, 
        (teacherReducer) => ({
            teachers: teacherReducer.teachers,
            loading: teacherReducer.loading
        })
    );

    const {teachers} = useSelector(TeacherProperties);

    // Selector Semesters
    const SemesterProperties = createSelector(
        (state) => state.semesterReducer, 
        (semesterReducer) => ({
            semesters: semesterReducer.semesters,
            loading: semesterReducer.loading
        })
    );

    const {semesters} = useSelector(SemesterProperties);

    // Chargement initial des données
    useEffect(() => {
        if (!courseComponents.length) dispatch(onGetCourseComponents());
        if (!studyLevels.length) dispatch(onGetStudyLevels());
        if (!teachers.length) dispatch(onGetTeachers());
        if (!semesters.length) dispatch(onGetSemesters());
        setLoadingState(loading);
    }, [dispatch, courseComponents.length, studyLevels.length, teachers.length, semesters.length,  loading]);

    

    /*
    // On mounting
    useEffect(() => {
        
        if (courseComponents && !courseComponents.length) {
            dispatch(onGetCourseComponents());
        }

    }, [dispatch,  courseComponents]);


    // On mounting
    useEffect(() => { 

        if (studyLevels && !studyLevels.length) {
            dispatch(onGetStudyLevels());
        }


         if (teachers && !teachers.length) {
            dispatch(onGetTeachers());
        }

    }, [dispatch,  studyLevels,  teachers]);

    */

    // Ferme le modal en cas de success
    useEffect(() => {
        
    if (lastActionSuccess && modal) {
        toggle();
        setCourseComponent(null);
        dispatch(OnResetCourseComponentLastActionSuccess()); // action qui remet à false
    }
    }, [lastActionSuccess, modal, dispatch]);


    // Toggle modal
    const toggle = () => {
        setModal(!modal);
        if (modal) setCourseComponent(null);
    };

    // Créer nouvelle course component
    const onClickNewCourseComponent = () => {
        setIsEdit(false);
        setCourseComponent(null);
        toggle();
    };

    // Edit course component
      const handleCourseComponentClick = (courseComponent) => {
        setCourseComponent(courseComponent);
        setIsEdit(true);
        toggle();
        dispatch(OnResetCourseComponentLastActionSuccess()); // reset pour l’édition
      };
    
      // Delete course component
      const onClickDelete = (courseComponent) => {
        setCourseComponent(courseComponent);
        setDeleteModal(true);
      };
      const handleDeleteCourseComponent = () => {
        if (courseComponent?.id) {
          dispatch(onDeleteCourseComponent(courseComponent));
          setDeleteModal(false);
        }
      };

      const handleSuccess = (data) => {
        console.log("Import réussi :", data);
        // ici tu peux recharger la liste des facultés si besoin
    };

    

    const columns = useMemo(
        () => [
            {
                header: 'ID',
                accessorKey: "id",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
                }
            },
            {
                header: "Nom",
                accessorKey: "title",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Code",
                accessorKey: "code",
                enableColumnFilter: false,
                enableSorting: true,
            },
            
            {
                header: "Semestre",
                accessorKey: "semester.code",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Niveau d'étude",
                accessorKey: "study_level.name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Enseignant",
                accessorKey: "teacher_name",
                enableColumnFilter: false,
                enableSorting: true,
            },

            {
                header: "Type",
                accessorKey: "type",
                enableColumnFilter: false,
                enableSorting: true,
            },
            
            
            
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            
                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        handleCourseComponentClick(jobData);
                                    }}
                                    id={`edittooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-pencil-outline" />
                                    <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.id}`} >
                                        Edit
                                    </UncontrolledTooltip>
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-danger"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        //console.log("ON DELETE: ", jobData);
                                        onClickDelete(jobData);
                                    }}
                                    id={`deletetooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-delete-outline" />
                                    <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.original.id}`}>
                                        Delete
                                    </UncontrolledTooltip>
                                </Link>
                            </li>
                        </ul>
                    );
                }
            },
        ],
        []
    );

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeleteCourseComponent}
                onCloseClick={() => setDeleteModal(false)}
            />
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Éléments constitutifs" breadcrumbItem="Liste des éléments constitutifs" />
                    {
                        isLoading ? <Spinners setLoading={setLoading} />
                            :
                            <Row>
                                <Col lg="12">
                                    <Card>
                                        <CardBody className="border-bottom">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1"></h5> 
                                                 <div className="d-flex gap-2">
                                                    <Button color="success" onClick={() => setModalOpen(true)}>
                                                        Importer un fichier
                                                    </Button>


                                                    <Link to="#!" onClick={onClickNewCourseComponent} className="btn btn-primary me-1">Ajouter un élément constitutif</Link>
                                                    
                                                </div>
                                            </div>
                                        </CardBody>
                                        <CardBody>
                                            <TableContainer
                                                columns={columns}
                                                data={courseComponents || []}
                                                isCustomPageSize={true}
                                                isGlobalFilter={true}
                                                //isJobListGlobalFilter={false}
                                                isPagination={true}
                                                SearchPlaceholder="Rechercher ..."
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                      
                        
                                                
                                                //tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                                                pagination="pagination"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                    }

                     {/* Modal séparé */}
                    <CourseComponentModal
                        modal={modal}
                        toggle={toggle}
                        isEdit={isEdit}
                        courseComponent={courseComponent}
                        semesters={semesters}
                        studyLevels={studyLevels}
                        teachers={teachers}
                        onSubmit={(payload) => {
                        if (isEdit) {
                            dispatch(onUpdateCourseComponent(payload));
                        } else {
                            dispatch(onAddNewCourseComponent(payload));
                        }
                        //toggle(); // 🔹 Fermeture automatique après succès
                        }}
                    />
                    
                </div>
            </div>
            <ToastContainer />

            <ImportCourseComponentModal
                isOpen={modalOpen}
                toggle={() => setModalOpen(!modalOpen)}
                onSuccess={handleSuccess}
            />
        </React.Fragment>
    );
}


export default Subject;